<template>
<div>
    <div class="center fs18" style="padding-top: 40px;">
        <p class="black fs32 fw500">{{ $t('favorite1') }}</p>
        <span class="backyel dib divide"></span>
    </div>
    <div :class="$style.body">
        <div class="dflex fw mb30">
            <card v-for="item in list" :key="item.code" :item="item" :class="$style.card"></card>
        </div>
        <!-- <div class="center">
            <img :src="whatsurl" alt="" style="width: 400px; margin-top:30px;margin-bottom:40px;">
        </div> -->
        <div class="dflex fcenter">
            <uwhatsapp></uwhatsapp>
        </div>
    </div>
</div>
</template>
<script>
// import whatsen from '../assets/whatsen.png';
// import whatszh from '../assets/whatszh.png';

export default {
    name: 'Favorites',
    data() {
        return {
            // whatsurl: this.$i18n.locale === 'en' ? whatsen : whatszh,
            list: [],
        };
    },
    created() {
        this.$service.getFavoritesList().then((data) => {
            this.list = data;
            this.list.forEach((item) => {item['is_favorite'] = true})
        })
        this.$top();
    },
}
</script>
<style module>
.card {
    width: 45%;
    margin-right: 50px;
    margin-bottom: 60px;
}
.body {
    margin: 0px 140px;
}
@media screen and (max-width: 770px) {
    .card {
        width: 100%;
        margin-bottom: 20px;
        margin-right: 0px;
    }
    .body {
        margin: 0px 20px;
    }
}
</style>
